import { I18n } from "vue-i18n";
import { ElNotification } from "element-plus";
import { h } from "vue";

export function onRouteError(error, to, i18n) {
  if (
    error.message.includes("Failed to fetch dynamically imported module") ||
    error.message.includes("Importing a module script failed") ||
    error.message.includes("error loading dynamically imported module")
  ) {
    ElNotification({
      title: i18n.global.t("error"),
      message: h(
        "a",
        {
          href: "javascript:window.location.reload(true)",
        },
        i18n.global.t("outdatedVersionReloadPage"),
      ),
      type: "error",
      duration: 0,
    });
  }
}
